import { LtvValueBasis } from './enums/ltv-value-basis.enum';

export class LoanType {
  loanTypeId: number | undefined;
  loanTypeName: string | undefined;
  mortgageAppliedForType: string | undefined;
  ltvValueBasis: LtvValueBasis | undefined;
  order: number | undefined;
  defaultForOnlineApp: boolean = false;
}
